import { render, staticRenderFns } from "./addLanguage.vue?vue&type=template&id=7aa947f4&scoped=true"
import script from "./addLanguage.vue?vue&type=script&lang=js"
export * from "./addLanguage.vue?vue&type=script&lang=js"
import style0 from "./addLanguage.vue?vue&type=style&index=0&id=7aa947f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa947f4",
  null
  
)

export default component.exports